import type { MentionEntity } from '@terra/shared-dto-chat-types';
import type { MentionEntityWithOffset } from '../editor/lexical/plugins/buildMessageSegments';
import type { ChatMentionsMenuItemType } from '../mentions/types';
import { hasRichCardRenderer } from '../mentions/mention-config';

export function collectMentionEntitiesForSend({
  selectedMentions,
  positionedMentions,
}: {
  selectedMentions: ChatMentionsMenuItemType[];
  positionedMentions: MentionEntityWithOffset[];
}): MentionEntity[] {
  const byEntityId = new Map<string, MentionEntity>();

  for (const item of selectedMentions) {
    const mentionEntity = item.mentionEntity;

    if (!mentionEntity?.entityId || !mentionEntity.entityType) {
      continue;
    }

    const hasRichCard = hasRichCardRenderer(mentionEntity.entityType);

    byEntityId.set(mentionEntity.entityId, {
      entityType: mentionEntity.entityType,
      entityId: mentionEntity.entityId,
      label: mentionEntity.label,
      extraData: hasRichCard ? mentionEntity.extraData : {},
    });
  }

  for (const positionedMention of positionedMentions) {
    if (byEntityId.has(positionedMention.entityId)) {
      continue;
    }

    byEntityId.set(positionedMention.entityId, {
      entityType: positionedMention.entityType,
      entityId: positionedMention.entityId,
      label: positionedMention.label,
      extraData: positionedMention.extraData ?? {},
    });
  }

  return Array.from(byEntityId.values());
}
